var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 95,
    viewBox: "0 0 78 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_14659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9201 91.4098C46.9201 91.4098 46.5401 92.2198 46.4801 92.5398C46.3501 93.3498 46.9301 93.6098 47.5501 93.9398C48.5301 94.4598 51.7401 94.6498 52.7601 93.6798C53.7801 92.7098 50.3601 90.7998 50.3601 90.7998C50.3601 90.7998 47.4801 91.0098 46.9201 91.3998V91.4098Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.91 72.2095C34.91 72.2095 40.46 81.8995 46.22 91.5695C46.74 92.1795 46.96 92.2395 48.1 92.0695C49.24 91.8995 50.26 91.0095 50.52 90.6395C50.78 90.2695 50.68 89.9995 50.51 89.5595C50.34 89.1195 44.15 71.2695 44.15 71.2695L34.9 72.2095H34.91Z",
    fill: "#898DA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.95 80.7797C25.95 80.7797 25.61 79.9497 25.41 79.6897C24.9 79.0497 24.26 79.1897 23.65 79.5297C23.04 79.8797 20.87 81.7297 20.98 83.1297C21.26 86.4997 25.62 83.3197 25.62 83.3197C25.62 83.3197 25.85 81.4497 25.94 80.7697L25.95 80.7797Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.74 70.25C27.74 70.25 26.97 75.23 26.96 80.03C26.43 79.8 26.38 79.86 25.71 79.75C25.04 79.64 24.73 79.6 23.87 80.36C23 81.13 22.39 82.86 23.58 83.46C24.32 83.83 26.72 85.97 29.35 86.1C32.68 86.26 33.58 84.55 34.55 79.93C35.47 75.57 36.54 71.9 36.54 71.9L27.75 70.26L27.74 70.25Z",
    fill: "#898DA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.47 64.5794C33.44 62.9494 26.8 59.5694 26.8 59.5694C26.8 59.5694 24.13 57.7094 24.3 55.1094C24.37 54.0494 25.25 53.0094 26.83 52.2994C27.39 52.0494 27.97 51.8594 28.44 52.2594C28.44 52.2594 39.92 60.1994 40.19 60.3994C40.46 60.5994 36.39 65.3094 35.47 64.5694V64.5794Z",
    fill: "white",
    stroke: "#BADED4",
    strokeWidth: 0.61,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.31 39.9794C55.47 40.2294 54.51 41.1694 54.84 41.0194C56.93 40.0794 61.44 41.7294 60.34 44.0694C59.72 45.3894 57.01 44.7094 54.81 46.5594C53.58 47.5894 51.8 45.6794 51.65 44.2294C51.5 42.7794 52.74 39.6394 54.3 39.9694L54.31 39.9794Z",
    fill: "#F6E1D3",
    stroke: "#F1CAB1",
    strokeWidth: 0.43,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7101 54.0699L35.7401 52.6899C35.7401 52.3999 38.6101 51.9499 38.8101 51.7399C39.0901 51.4299 39.7001 50.8399 40.6801 50.1599C42.8501 48.6499 51.6801 42.3799 51.6801 42.3799C51.6801 42.3799 52.6001 41.8599 53.1101 41.9499C54.1801 42.1399 54.8901 43.4799 55.1301 45.2199C55.2201 45.8399 55.2301 46.4599 54.7101 46.7999C54.7101 46.7999 43.6901 55.7499 43.4101 55.9499C43.1301 56.1499 41.1201 59.3599 41.6401 60.7799C42.1601 62.1999 35.6901 55.0499 35.7201 54.0699H35.7101Z",
    fill: "white",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.41 49.0393C36.41 49.0393 36.04 51.0993 38.84 51.9693L36.9 71.3293L29.27 51.8593C31.33 51.1993 30.73 49.2993 30.73 49.2993L36.4 49.0293L36.41 49.0393Z",
    fill: "#F6E1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9301 52.2397C31.9301 52.2397 30.8301 52.0797 30.8301 52.5697C31.9401 53.5897 33.9301 53.3697 34.7101 53.2297C35.8201 53.0197 37.3901 52.4597 37.4001 51.4797C37.2801 51.0997 37.5301 51.2997 37.5301 51.2997L31.9301 52.2397Z",
    fill: "#F1CAB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.64 52.9395L37.13 66.4795L30.9 54.1695C35.77 56.2595 38.64 52.9395 38.64 52.9395Z",
    fill: "#05375B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9401 70.7592C45.9401 70.7592 43.5201 65.5092 42.1901 62.4592C40.8601 59.4092 40.3101 56.2792 40.3101 56.2792L38.9101 53.7592L39.7901 50.3792C37.8601 49.8692 37.98 50.3792 36.67 50.2992C37.2701 51.3692 37.7101 52.7992 37.6501 55.2392C37.5901 57.4692 36.1501 62.4892 36.1301 62.5192C36.1101 62.4192 32.4701 57.3792 32.0201 55.5192C31.5701 53.6592 30.7401 51.6492 30.7001 50.4192C29.6401 50.6792 29.8701 51.2692 27.9301 52.0392L27.6301 54.9392L26.7601 57.9892L27.3001 60.2992L24.2201 72.2092C24.2201 72.2092 23.6901 74.6792 25.2301 75.5192C27.1001 76.5392 28.7801 77.2992 30.6901 77.9192C31.2901 78.1092 32.9601 78.2792 33.6401 78.2592C34.4201 78.2392 35.65 77.4192 36.17 76.9792C36.4801 76.7092 36.7101 76.3992 36.9001 76.0692C37.1301 76.3692 37.4001 76.6492 37.7501 76.8792C38.3301 77.2492 39.1501 77.5492 39.9301 77.4692C40.6001 77.3992 41.2001 77.1192 41.7701 76.8492C43.5901 75.9792 44.4701 75.2292 45.8001 73.9292C47.0501 72.7092 45.9401 70.7792 45.9401 70.7792V70.7592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3401 59.5591L24.2101 72.1891C24.2101 72.1891 23.6301 74.0591 24.9401 75.2191C26.5801 76.6791 28.7201 77.4791 30.6901 77.8991C32.6601 78.3191 33.4201 78.3091 34.2201 78.0991C35.0701 77.8791 35.5701 77.2391 36.0901 76.7991C36.4001 76.5291 36.6301 76.2191 36.8201 75.8891C37.0501 76.1891 37.3201 76.4691 37.6701 76.6991C38.2501 77.0691 39.0701 77.3691 39.8501 77.2891C40.5201 77.2191 40.6501 77.1191 41.2201 76.8491C43.0401 75.9791 43.9701 75.5191 45.5801 73.9991C46.8501 72.7991 45.9401 70.7691 45.9401 70.7691L40.5101 57.8691M36.1201 62.5391C36.1201 62.5391 36.1201 62.5091 36.1101 62.4991L36.1301 62.5191C36.1301 62.5191 36.1301 62.5291 36.1301 62.5391H36.1201Z",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 62.5095L39.61 56.4495L37.85 55.6895",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.97 55.5898L29 57.1498L36.13 62.5198",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0601 55.4398L39.6201 50.3598C38.6301 50.1198 37.6001 50.3698 36.8201 50.0098",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3201 60.3994L41.0101 62.6794C41.0901 62.9594 40.9101 63.2494 40.5901 63.3294L38.6301 63.8194C38.3101 63.8994 37.9901 63.7394 37.9001 63.4594L37.2101 61.1794L40.3201 60.3994Z",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3501 62.8301L36.7601 75.6601",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.24 65.8396C34.5824 65.8396 34.86 65.562 34.86 65.2196C34.86 64.8772 34.5824 64.5996 34.24 64.5996C33.8976 64.5996 33.62 64.8772 33.62 65.2196C33.62 65.562 33.8976 65.8396 34.24 65.8396Z",
    fill: "#BADED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.29 56.0491L27.76 52.1391C27.76 52.1391 29.01 51.8891 30.49 50.3691",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7701 22.3799C51.8701 35.4299 47.6601 48.2699 34.6201 52.3799C21.5701 56.4799 9.76006 48.5699 5.66006 35.5199C1.56006 22.4699 8.26006 13.9199 21.3101 9.81989C34.3601 5.71989 43.6701 9.32989 47.7701 22.3799Z",
    fill: "#F6E1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0501 44.8896C37.8801 51.7196 32.6601 51.1796 31.0901 46.6696L37.0501 44.8896Z",
    fill: "#E6857F",
    stroke: "#E6857F",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.45 7.28959C27.45 7.28959 16.95 0.279591 6.11004 13.9096C-4.72996 27.5496 -2.48996 57.6096 23.76 58.4996C23.24 58.4696 22.13 56.7896 21.86 56.4596C20.26 54.4896 18.89 52.3096 17.77 50.0296C14.33 43.0196 13.59 34.2996 16.72 27.0296C17.92 24.2296 19.52 21.5596 21.62 19.3496C23.56 17.3096 26.1 15.0496 28.91 14.3896C30.38 14.0496 31.05 13.8396 32.44 14.4896C34 15.2196 35.57 16.4896 36.72 17.7796C41.63 23.2596 44.5 27.9996 46.42 36.4096C47.44 40.8796 45.51 45.4996 43.75 48.2096C47.21 46.9296 50.73 41.5996 51.38 37.2396C51.76 34.6796 51.89 31.8696 51.68 29.2896C50.37 13.4596 32.55 0.709591 27.45 7.28959Z",
    fill: "#5C3329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.61 35.7996C26.61 35.7996 20.91 33.0896 18 38.1596",
    stroke: "#030000",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 40.5993C20.3701 43.0493 22.5601 44.5393 24.4901 43.9393C26.4201 43.3293 27.3601 40.8593 26.5901 38.4093C25.8201 35.9593 23.6301 34.4693 21.7001 35.0693C19.7701 35.6693 18.8301 38.1493 19.6001 40.5993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 47.39C17.06 47.97 18.98 47.87 21.18 47.19C23.37 46.5 25 45.48 24.82 44.9C24.64 44.32 22.72 44.41 20.52 45.1C18.33 45.79 16.7 46.82 16.88 47.39Z",
    fill: "#FBBEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93 31.4199C25.93 31.4199 20.84 29.4799 16.39 32.8499",
    stroke: "#5C3329",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5001 37.8096C24.7201 38.5196 24.6101 39.1796 24.2401 39.2996C23.8701 39.4196 23.4001 38.9296 23.1801 38.2196C22.9601 37.5096 23.0701 36.8396 23.4301 36.7296C23.7901 36.6196 24.2701 37.0996 24.4901 37.8096H24.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8101 33.4691C33.8101 33.4691 36.3701 28.1691 41.1201 30.8191",
    stroke: "#030000",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3101 33.7191C42.0801 36.1691 41.3401 38.5791 39.6601 39.1091C37.9801 39.6391 35.9901 38.0791 35.2201 35.6291C34.4501 33.1791 35.1901 30.7691 36.8701 30.2391C38.5501 29.7091 40.5301 31.2691 41.3001 33.7191H41.3101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.85 37.9091C47.03 38.4891 45.63 39.4391 43.72 40.0391C41.81 40.6391 40.12 40.6591 39.94 40.0791C39.76 39.4991 41.16 38.5491 43.07 37.9491C44.98 37.3491 46.67 37.3291 46.85 37.9091Z",
    fill: "#FBBEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9501 29.4691C31.9501 29.4691 34.6001 25.5291 39.7501 25.3691",
    stroke: "#5C3329",
    strokeWidth: 0.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 33.4192C38.47 34.1292 38.91 34.6192 39.23 34.5192C39.55 34.4192 39.62 33.7692 39.4 33.0592C39.18 32.3492 38.74 31.8592 38.42 31.9592C38.1 32.0592 38.03 32.7092 38.25 33.4192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 70.3694L27.17 73.0994C27.06 73.5194 27.19 74.2094 27.74 74.5294C28.79 75.1394 31.24 75.8494 31.24 75.8494C31.69 75.9794 32.15 75.7094 32.25 75.2494L33.25 71.9594C30.85 71.5694 29.74 71.1494 28.15 70.3594V70.3694Z",
    stroke: "#BADED4",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 69.5098L44.32 71.5898C44.53 71.9698 44.51 72.6298 44.23 72.8298C44.23 72.8298 43.17 73.7498 41.74 74.3198C41.29 74.4998 40.88 74.2598 40.75 73.8098L39.78 71.4198C41.65 70.8298 43.51 69.5098 43.51 69.5098H43.5Z",
    stroke: "#BADED4",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61 51.5893C47.68 52.0393 46.58 52.7793 46.94 52.6893C49.13 52.1593 53.19 54.5793 51.7 56.6393C50.86 57.7993 48.54 56.7193 45.19 57.3493C43.64 57.6393 43.16 56.6493 43.28 55.2193C43.4 53.7893 45.16 50.9793 46.62 51.5893H46.61Z",
    fill: "#F6E1D3",
    stroke: "#F1CAB1",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6801 58.5499C27.4401 60.4499 33.0601 61.0299 34.7301 60.6499C37.8901 59.9399 44.5001 58.3199 44.5001 58.3199C44.5001 58.3199 45.5401 58.3499 45.4801 57.1999C45.4401 56.2899 45.4601 55.5299 45.0601 54.1699C44.8501 53.4599 44.1201 53.0299 43.3901 53.1699L34.0801 55.5399L29.0801 54.4499",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6801 58.5499C27.4401 60.4499 33.0601 61.0299 34.7301 60.6499C37.8901 59.9399 44.5001 58.3199 44.5001 58.3199C44.5001 58.3199 45.5401 58.3499 45.4801 57.1999C45.4401 56.2899 45.4601 55.5299 45.0601 54.1699C44.8501 53.4599 44.1201 53.0299 43.3901 53.1699L34.0801 55.5399L29.0801 54.4499",
    stroke: "#BADED4",
    strokeWidth: 0.61,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.01 29.7496C68.38 30.0996 69.25 30.4496 70.12 30.7396C70.78 30.9496 70.8 31.8796 70.15 32.1196C69.29 32.4396 68.43 32.8296 68.08 33.1896C67.73 33.5596 67.38 34.4296 67.09 35.2996C66.88 35.9596 65.95 35.9796 65.71 35.3296C65.39 34.4696 65 33.6096 64.64 33.2596C64.27 32.9096 63.4 32.5596 62.53 32.2696C61.87 32.0596 61.85 31.1296 62.5 30.8896C63.36 30.5696 64.22 30.1796 64.57 29.8196C64.92 29.4496 65.27 28.5796 65.56 27.7096C65.77 27.0496 66.7 27.0296 66.94 27.6796C67.26 28.5396 67.65 29.3996 68.01 29.7496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.31 19.6001C75.68 19.9501 76.55 20.3001 77.42 20.5901C78.08 20.8001 78.1 21.7301 77.45 21.9701C76.59 22.2901 75.73 22.6801 75.38 23.0401C75.03 23.4101 74.68 24.2801 74.39 25.1501C74.18 25.8101 73.25 25.8301 73.01 25.1801C72.69 24.3201 72.3 23.4601 71.94 23.1101C71.57 22.7601 70.7 22.4101 69.83 22.1201C69.17 21.9101 69.15 20.9801 69.8 20.7401C70.66 20.4201 71.52 20.0301 71.87 19.6701C72.22 19.3001 72.57 18.4301 72.86 17.5601C73.07 16.9001 74 16.8801 74.24 17.5301C74.56 18.3901 74.95 19.2501 75.31 19.6001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8101 4.83027C60.5101 5.50027 62.1601 6.16027 63.8201 6.70027C65.0701 7.11027 65.1001 8.86027 63.8701 9.32027C62.2301 9.93027 60.6101 10.6603 59.9401 11.3603C59.2701 12.0603 58.6101 13.7103 58.0601 15.3703C57.6501 16.6203 55.9001 16.6503 55.4401 15.4203C54.8301 13.7803 54.1001 12.1603 53.4001 11.4903C52.7001 10.8203 51.0501 10.1603 49.3901 9.62027C48.1401 9.21027 48.1101 7.46027 49.3401 7.00027C50.9801 6.39027 52.6001 5.66027 53.2701 4.96027C53.9401 4.26027 54.6001 2.61027 55.1401 0.950266C55.5501 -0.299734 57.3001 -0.339734 57.7601 0.900266C58.3701 2.54027 59.1001 4.16027 59.8001 4.83027H59.8101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_14659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.92,
    height: 94.38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherIcon);
export default __webpack_public_path__ + "static/media/teacherIcon.577a3333a7094609ab32edc5e4faa908.svg";
export { ForwardRef as ReactComponent };